const DAY = 86400000;
export const number = value => new Intl.NumberFormat('pt-BR', { maximumFractionDigits: 1 }).format(value || 0);
export const percent = (value, total) => total > 0 ? (value / total) * 100 : 0;
export const dayKey = date => date.toISOString().slice(0, 10);
export const dateLabel = (date, full = false) => date ? new Date(`${date}T12:00:00Z`).toLocaleDateString('pt-BR', {
  day: '2-digit', month: '2-digit', ...(full ? { year: 'numeric' } : {}), timeZone: 'UTC'
}) : '—';
export const count = value => Math.max(0, Number(value) || 0);

export function periodPreset(days, now = new Date()) {
  if (!days) return { startDate: '', endDate: '' };
  const endDate = dayKey(now);
  return { startDate: dayKey(new Date(new Date(`${endDate}T00:00:00Z`).getTime() - (days - 1) * DAY)), endDate };
}

// O backend agrega por dia UTC. Não converter estes rótulos para o dia local.
export function buildTimeline(reports, filters, now = new Date()) {
  const totals = new Map();
  reports.forEach(report => Object.entries(report.acessosPorDia || {}).forEach(([date, value]) => {
    if (/^\d{4}-\d{2}-\d{2}$/.test(date)) totals.set(date, (totals.get(date) || 0) + count(value));
  }));
  const dates = [...totals.keys()].sort();
  const start = filters.startDate || dates[0] || filters.endDate || dayKey(now);
  const end = filters.endDate || dayKey(now);
  const result = [];
  for (let time = Date.parse(`${start}T00:00:00Z`); time <= Date.parse(`${end}T00:00:00Z`); time += DAY) {
    const date = dayKey(new Date(time));
    result.push({ date, total: totals.get(date) || 0 });
  }
  return result;
}

export function groupTimeline(daily, mode = 'day') {
  const groups = new Map();
  daily.forEach(item => {
    const date = new Date(`${item.date}T00:00:00Z`);
    if (mode === 'week') date.setUTCDate(date.getUTCDate() - ((date.getUTCDay() + 6) % 7));
    if (mode === 'month') date.setUTCDate(1);
    const key = dayKey(date);
    const existing = groups.get(key);
    if (existing) {
      existing.total += item.total;
      existing.end = item.date;
    } else groups.set(key, { date: key, start: item.date, end: item.date, total: item.total });
  });
  return [...groups.values()];
}

export function aggregateStates(reports) {
  const states = new Map();
  reports.forEach(report => (report.acessosPorEstado || []).forEach(state => {
    const previous = states.get(state.code);
    states.set(state.code, { ...state, count: (previous?.count || 0) + count(state.count) });
  }));
  return [...states.values()].sort((a, b) => b.count - a.count);
}

export function buildRows(reports, inventory, qrId = '') {
  const byId = new Map(inventory.filter(qr => !qrId || qr.id === qrId).map(qr => [qr.id, {
    qrId: qr.id, nome: qr.nome, urlDestino: qr.urlDestino, totalAcessos: 0,
    acessosComLocalizacao: 0, acessosPorDia: {}, acessosPorEstado: [], acessosPorCidade: []
  }]));
  reports.filter(report => !qrId || report.qrId === qrId).forEach(report => byId.set(report.qrId, { ...byId.get(report.qrId), ...report }));
  return [...byId.values()].map(report => {
    const total = count(report.totalAcessos);
    const located = Math.min(total, count(report.acessosComLocalizacao));
    const dates = Object.keys(report.acessosPorDia || {}).filter(date => report.acessosPorDia[date] > 0).sort();
    return { ...report, totalAcessos: total, acessosComLocalizacao: located,
      coverage: percent(located, total), lastDay: dates[dates.length - 1] || '',
      nome: report.nome || report.qrId };
  });
}

export function createReportCsv(rows, filters) {
  const total = rows.reduce((sum, row) => sum + row.totalAcessos, 0);
  const escape = value => {
    let text = String(value ?? '');
    if (/^[\s]*[=+@-]/.test(text)) text = `'${text}`;
    return `"${text.replace(/"/g, '""')}"`;
  };
  const data = [['Nome', 'ID', 'Destino', 'Início (UTC)', 'Fim (UTC)', 'Acessos', 'Participação na exportação (%)', 'Localizados no Brasil', 'Localização (%)', 'Último dia com acessos (UTC)'],
    ...rows.map(row => [row.nome, row.qrId, row.urlDestino, filters.startDate, filters.endDate,
      row.totalAcessos, number(percent(row.totalAcessos, total)), row.acessosComLocalizacao, number(row.coverage), row.lastDay])];
  return '\uFEFF' + data.map(row => row.map(escape).join(';')).join('\r\n');
}

export function downloadReportCsv(rows, filters) {
  const blob = new Blob([createReportCsv(rows, filters)], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = `qrblant-relatorio-${filters.startDate || 'inicio'}-${filters.endDate || dayKey(new Date())}.csv`;
  document.body.appendChild(link);
  link.click();
  link.remove();
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}
